import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PageUrls } from '@constants/page-urls.constants';
import { DEFAULT_TENANT } from '@models/layout-state.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { SessionService } from '@services/session/session.service';
import { ViewService } from 'tangoe-design-system';

@Component({
  selector: 'ts-logout',
  templateUrl: './logout.component.html',
  imports: [CommonModule, TranslationPipe]
})
export class LogoutComponent {
  constructor(
    private router: Router,
    private session_svc: SessionService,
    private view_svc: ViewService
  ) {}

  getTenantName(): string {
    return this.session_svc.getTenantInfo()?.name || DEFAULT_TENANT;
  }

  showReturnToPortalButton(): boolean {
    return Boolean(this.session_svc.getRedirectUrl()) || this.isDevEnvironment();
  }

  isDevEnvironment(): boolean {
    return this.view_svc.isLocalhost();
  }

  redirectToPortal(): void {
    if (this.isDevEnvironment()) {
      this.router.navigate([PageUrls.LOGIN]);
      return;
    }

    this.view_svc.navigateToExternalUrl(this.session_svc.getRedirectUrl());
  }
}
